import React from 'react'
import PropTypes from 'prop-types';
import { Icon } from './styles';
const CustomIcon = ({name,variant}) => {
  return (
    <Icon variant={variant}>
      <span className="material-symbols-outlined">{name}</span>
    </Icon>
  )
}


CustomIcon.propTypes = {
    name: PropTypes.string,
    variant: PropTypes.oneOf(['pink', 'white', 'gray', 'purple', 'yellow', 'red','blue-light','green']),
  };

export default CustomIcon